export var ImageTypes;
(function (ImageTypes) {
    ImageTypes["MAIN"] = "main";
    ImageTypes["FRONT"] = "front";
    ImageTypes["REAR"] = "rear";
    ImageTypes["INTERIOR"] = "interior";
    ImageTypes["INTERIOR_360"] = "interior360";
    ImageTypes["EXTERIOR_360"] = "exterior360";
    ImageTypes["INTERIOR_360_PANORAMIC"] = "interior360panoramic";
    ImageTypes["FRONT360"] = "exterior360_31";
    ImageTypes["PROFILE"] = "profile";
    ImageTypes["IMAGE"] = "image";
})(ImageTypes || (ImageTypes = {}));
//# sourceMappingURL=ImageTypes.js.map